<!-- <mat-toolbar class="fixed-top">
    <div class="logo">MSME</div>
    <div class="top-menu text-end w-100">
      <ul class="top-menu-list">
        <li class="top-menu-item">
          <div class="d-flex form-inputs">
            <input class="form-control" type="text" placeholder="Search...">
            <mat-icon class="bx-search">search</mat-icon>
          </div>
        </li>
        <li class="top-menu-item">
          <button mat-button>
            <mat-icon>notifications_none</mat-icon>
          </button>
        </li>
        <li class="top-menu-item">
          <button mat-button [matMenuTriggerFor]="menu">
            <mat-icon>settings</mat-icon>
          </button>
          <mat-menu #menu="matMenu" class="user-menu" yPosition="below">
            <div class="row me-3 ms-3">
              <div class="col-md-3">
                <div class="mb-3">BASIC MASTER</div>
                <div class="tm-item">
                  <mat-icon class="menu-icon">date_range</mat-icon>
                  Project Master
                </div>
                <div class="tm-item">
                  <mat-icon class="menu-icon">date_range</mat-icon>
                  Customer Group
                </div>
                <div class="tm-item">
                  <mat-icon class="menu-icon">date_range</mat-icon>
                  Vendor Groups
                </div>
                <div class="tm-item">
                  <mat-icon class="menu-icon">date_range</mat-icon>
                  Currency Setup
                </div>
              </div>
              <div class="col-md-3">
                <div class="mb-3">USER SETTINGS</div>
                <div class="tm-item">
                  <mat-icon class="menu-icon">date_range</mat-icon>
                  User Master</div>
                <div class="tm-item">
                  <mat-icon class="menu-icon">date_range</mat-icon>
                  Employee Master</div>
                <div class="tm-item">
                  <mat-icon class="menu-icon">date_range</mat-icon>
                  password reset</div>
                <div class="tm-item">
                  <mat-icon class="menu-icon">date_range</mat-icon>
                  manage menu permission</div>
              </div>
              <div class="col-md-3">
                <div class="mb-3">CONFIGURATION</div>
                <div class="tm-item">
                  <mat-icon class="menu-icon">date_range</mat-icon>
                  Company Creation</div>
                <div class="tm-item">
                  <mat-icon class="menu-icon">date_range</mat-icon>
                  Branch Master</div>
                <div class="tm-item">
                  <mat-icon class="menu-icon">date_range</mat-icon>
                  document numbering setup</div>
                <div class="tm-item">
                  <mat-icon class="menu-icon">date_range</mat-icon>
                  location</div>
              </div>
              <div class="col-md-3">
                <div class="mb-3">OTHERS</div>
                <div class="tm-item">
                  <mat-icon class="menu-icon">date_range</mat-icon>
                  Opening Balance</div>
                <div class="tm-item">
                  <mat-icon class="menu-icon">date_range</mat-icon>
                  House Bank Account</div>
                <div class="tm-item">
                  <mat-icon class="menu-icon">date_range</mat-icon>
                  credit card master</div>
                <div class="tm-item">
                  <mat-icon class="menu-icon">date_range</mat-icon>
                  CRM > Stages management</div>
              </div>
            </div>
          </mat-menu>
        </li>
        <li class="top-menu-item">
          <span class="user-icon">
            <mat-icon>person</mat-icon>
          </span>
        </li>
      </ul>
    </div>
  </mat-toolbar> -->

<mat-toolbar class="fixed-top">

  <!-- <div class="logo d-none d-sm-block">{{'Language.HeaderText' | translate}}</div> -->
     <div class="logo d-none d-sm-block">  <img style="    padding-left: 10px;
    height: 44px;
    width: 112px;" src="./assets/images/icons/header-logo.png" alt="SAP Business One" ></div>

  <button mat-icon-button class="toggle-btn d-block d-sm-none" (click)="toggleSidebar()">
    <mat-icon>menu</mat-icon>
  </button>
  <!-- <breadcrumb #parent>
    <span class="breadcrumb" *ngFor="let route of parent.breadcrumbs">
      <a class="breadcrumb-ancor" *ngIf="!route.terminal" href="" [routerLink]="[route.url]">{{ route.displayName }}</a>
      <a class="breadcrumb-ancor breadcrumb-disable" *ngIf="route.terminal">/ {{ route.displayName }}</a>
    </span>
  </breadcrumb> -->

  <!-- <div class="mt-3 pt-2 ms-5 top-search">
    <mat-form-field class="full-width" appearance="outline">
      <input matInput placeholder="{{'Search' | translate }}">
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div> -->
  <!-- <div class="mt-3 pt-2 ms-5 languageSelect">
    <mat-form-field style="width:80%;">
      <mat-select value="selected" placeholder="Select MultiLanguage">
        <mat-option (click)="changeLanguge('en')" value="">English</mat-option>
        <mat-option (click)="changeLanguge('hi')" value="">Hindi</mat-option>
      </mat-select>
    </mat-form-field>
  </div> -->


  <div class="top-menu">
    <ul class="top-menu-list d-flex justify-content-end">
      <li class="top-menu-item">
        <button mat-button [matMenuTriggerFor]="menu" 
        class="reconnectBtn me-2">
          <mat-icon>palette &nbsp;</mat-icon>
          Theme
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item 
            [ngClass]="{'active-menu': this.isBlueTheme}" 
            (click)="themeSwitch('blue')">Purple
          </button>
          <button mat-menu-item 
            [ngClass]="{'theme-green': !this.isBlueTheme}" 
            (click)="themeSwitch('green')">Green</button>
          </mat-menu>
      </li>
      <li class="top-menu-item">
        <button mat-button class="reconnectBtn" (click)="reconnectSub.next(true)">
          <mat-icon>refresh &nbsp;</mat-icon>
          Reconnect
        </button>
        <!-- <button  matTooltip="Reconnect" class="icon-button me-2" mat-stroked-button (click)="reconnectSub.next(true)">
          <mat-icon>refresh &nbsp;</mat-icon>
          <span class="d-none d-sm-block">Reconnect</span> 
        </button> -->
         <!-- <button  matTooltip="Reconnect"  class="icon-button ps-2" mat-stroked-button >
          <mat-icon>refresh &nbsp;</mat-icon>
          Reconnect
        </button> -->
      </li>
      <li class="top-menu-item">
        <!-- <button mat-button (click)="onOpenDropDown('Branch');">
          Change Branch
        </button> -->
        <button class="icon-button ps-2 ms-2" matTooltip="Change Branch" mat-stroked-button (click)="onOpenDropDown('Branch');">
          <!-- <mat-icon>settings_input_antenna &nbsp;</mat-icon> -->
           <mat-icon>warehouse &nbsp;</mat-icon>
          <span class="d-none d-sm-block">Change Branch</span>
        </button>
      </li>
      <li class="top-menu-item">
        <!-- <button mat-button class="" [matMenuTriggerFor]="menu1">
          <img src="./assets/images/icons/hrms.svg" alt="" class="">
        </button> -->
        <!-- <button mat-button class="" [matMenuTriggerFor]="menu1">
          <img src="./assets/images/icons/app.svg" alt="" class="">
        </button> -->
        <mat-menu #menu1="matMenu" class="external-menu" yPosition="below">
          <div class="arrow-up"></div>
          <p class="external-menu-heading">APPLICATION</p>
          <mat-list class="d-flex">
            <mat-list-item class="text-center">
              <img src="./assets/images/icons/left menu/hrms.svg" alt="" class="">
              <span class="d-block">HRMS</span>
            </mat-list-item>
            <mat-list-item class="text-center">
              <img src="./assets/images/icons/left menu/ess.svg" alt="" class="">
              <span class="d-block">ESS</span>
            </mat-list-item>
            <mat-list-item class="text-center">
              <img src="./assets/images/icons/left menu/hrms.svg" alt="" class="">
              <span class="d-block">Website</span>
            </mat-list-item>
          </mat-list>
        </mat-menu>
      </li>
      <li class="top-menu-item">
        <!-- <button mat-button [matMenuTriggerFor]="menu" class="">
          <img src="./assets/images/icons/header/settings.svg" alt="" class="">
        </button> -->
        <mat-menu #menu="matMenu" class="user-menu" yPosition="below">
          <div class="arrow-up"></div>
          <perfect-scrollbar style="height: calc(100vh - 150px);">
            <mat-list>
              <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/generalsettingentryform/1">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/projectW.svg" alt="" class="">
                    <span>General Setting</span>
                  </a>
                </div>

              </mat-list-item>
              <!-- <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/goodsIssueListView">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/projectW.svg" alt="" class="">
                    <span>Goods Issue</span>
                  </a>
                </div>

              </mat-list-item> -->
              <!-- <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/goodsReceiptListView">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/projectW.svg" alt="" class="">
                    <span>Goods Receipt</span>
                  </a>
                </div>

              </mat-list-item> -->
              <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/projectmasterlist">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/projectW.svg" alt="" class="">
                    <span>Project Master</span>
                    <span class="um-tag ms-1">Not Added</span>
                  </a>
                </div>

              </mat-list-item>

              <mat-list-item class="active">
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/customerGroupList">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/customerW.svg" alt="" class="">
                    <span>Customer Group</span>

                  </a>
                </div>
                <!-- <mat-icon matListItemIcon>folder</mat-icon> -->


              </mat-list-item>
              <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/vendorGrouplist">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/vendorW.svg" alt="" class="">
                    <span>Vendor Groups</span>

                  </a>
                </div>
                <!-- <mat-icon matListItemIcon>folder</mat-icon> -->

              </mat-list-item>
              <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/currencysetuplistview">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/currencyW.svg" alt="" class="">
                    <span>Currency Setup</span>
                  </a>
                </div>

              </mat-list-item>
              <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/exchangeratemasterentryform">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/paymentW.svg" alt="" class="">
                    <span>Exchange Rate Master</span>
                  </a>
                </div>
              </mat-list-item>
              <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/paymenttermsmasterlistview">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/paymentW.svg" alt="" class="">
                    <span>Payment Terms</span>
                  </a>
                </div>
              </mat-list-item>
              <!-- <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/partnersmasterlistview">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/paymentW.svg" alt="" class="">
                    <span>Partners</span>
                  </a>
                </div>
              </mat-list-item> -->
              <!-- <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/relationshipmasterlistview">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/paymentW.svg" alt="" class="">
                    <span>Relationship</span>
                  </a>
                </div>
              </mat-list-item> -->
              <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/departmentmasterlistview">
                  <!-- <mat-icon matListItemIcon>folder</mat-icon> -->
                  <img src="./assets/images/icons/settings icon/white/departmentW.svg" alt="" class="">
                  <span>Department Master</span>
                </div>
              </mat-list-item>

              <!-- <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/transportermasterlistview">
                  <img src="./assets/images/icons/settings icon/white/departmentW.svg" alt="" class="">
                  <span>Transporter Master</span>
                </div>
              </mat-list-item> -->


            </mat-list>
            <hr />
            <mat-list>
              <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/usermasterlistview">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/userW.svg" alt="" class="">
                    <span>User Master</span>
                    <span class="um-tag ms-1">Not Added</span>
                  </a>
                </div>

              </mat-list-item>
              <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/employeeMasterlist">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/employeeW.svg" alt="" class="">
                    <span>Employee Master</span>
                  </a>
                </div>
              </mat-list-item>

              <mat-list-item>
                <!-- <mat-icon matListItemIcon>folder</mat-icon> -->
                <img src="./assets/images/icons/settings icon/white/passwordW.svg" alt="" class="">
                <span>Password Reset</span>
              </mat-list-item>
              <mat-list-item>
                <!-- <mat-icon matListItemIcon>folder</mat-icon> -->
                <img src="./assets/images/icons/settings icon/white/manage-menuW.svg" alt="" class="">
                <span>Manage Menu Permission</span>
              </mat-list-item>
              <mat-list-item>
                <!-- <mat-icon matListItemIcon>folder</mat-icon> -->
                <img src="./assets/images/icons/settings icon/white/manage-screenW.svg" alt="" class="">
                <span>Manage Screen Authorisation</span>
              </mat-list-item>


            </mat-list>
            <hr />
            <mat-list>
              <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/companyDetailsentryform/1">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/companyW.svg" alt="" class="">
                    <span>Company Creation</span>
                  </a>
                </div>

              </mat-list-item>

              <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}" rout
                  erLink="/settings/brancheslist">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/branchW.svg" alt="" class="">
                    <span>Approval Stage</span>
                  </a>
                </div>
              </mat-list-item>

              <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}" rout
                  erLink="/settings/brancheslist">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/branchW.svg" alt="" class="">
                    <span>Branch Master</span>
                  </a>
                </div>
              </mat-list-item>
              <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/documentnumbringlist">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/documentW.svg" alt="" class="">
                    <span>Document Numbering Setup</span>
                  </a>
                </div>
              </mat-list-item>

              <!-- <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/costcenterlistview">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/departmentW.svg" alt="" class="">
                    <span>Cost Center</span>
                  </a>
                </div>
              </mat-list-item> -->

              <!-- <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/levelofinterestlistview">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/departmentW.svg" alt="" class="">
                    <span>Level Of Interest</span>
                  </a>
                </div>
              </mat-list-item> -->

              <!-- <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/interestrangelistview">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/departmentW.svg" alt="" class="">
                    <span>Interest Range</span>
                  </a>
                </div>
              </mat-list-item> -->

              <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/locationlist">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/locationW.svg" alt="" class="">
                    <span>Location</span>
                    <span class="um-tag ms-1">Not Added</span>
                  </a>
                </div>
                <!-- <mat-icon matListItemIcon>folder</mat-icon> -->

              </mat-list-item>
              <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/exchangeratemasterentryform">
                  <img src="./assets/images/icons/settings icon/white/exchageW.svg" alt="" class="">
                  <span>Exchange Rate Master</span>
                </div>
                <!-- <mat-icon matListItemIcon>folder</mat-icon> -->

              </mat-list-item>
              <mat-list-item>
                <!-- <mat-icon matListItemIcon>folder</mat-icon> -->
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/warehousemasterlistview">
                  <img src="./assets/images/icons/settings icon/white/warehouseW.svg" alt="" class="">
                  <span>Warehouse Master</span>
                </div>
              </mat-list-item>
              <mat-list-item>
                <!-- <mat-icon matListItemIcon>folder</mat-icon> -->
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/chartofaccountmasterlistview">
                  <img src="./assets/images/icons/settings icon/white/documentW.svg" alt="" class="">
                  <span>Chart Of Account</span>
                </div>
              </mat-list-item>
              <!-- <mat-list-item>
                <img src="./assets/images/icons/settings icon/white/settingsW.svg" alt="" class="">
                <span>General Settings</span>
              </mat-list-item> -->
            </mat-list>
            <hr />
            <mat-list>
              <mat-list-item>
                <!-- <mat-icon matListItemIcon>folder</mat-icon> -->
                <img src="./assets/images/icons/settings icon/white/opening-balanceW.svg" alt="" class="">
                <span>Opening Balance</span>
                <span class="um-tag ms-1">Not Added</span>
              </mat-list-item>
              <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/housebankaccountlistview">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/house-bankW.svg" alt="" class="">
                    <span>House Bank Master</span>
                  </a>
                </div>
              </mat-list-item>

              <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/creditcardmasterlistview">
                  <!-- <mat-icon matListItemIcon>folder</mat-icon> -->
                  <img src="./assets/images/icons/settings icon/white/creditW.svg" alt="" class="">
                  <span>Credit Card Master</span>
                </div>
              </mat-list-item>

              <!-- <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/billofmateriallistview">
                  <img src="./assets/images/icons/settings icon/white/creditW.svg" alt="" class="">
                  <span>Bill Of Material</span>
                </div>
              </mat-list-item> -->

              <!-- <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/recieptfromproductionlist">
                  <img src="./assets/images/icons/settings icon/white/creditW.svg" alt="" class="">
                  Receipt From Production Order
                </div>
              </mat-list-item> -->


              <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/stagesmanagementmasterlistview">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/paymentW.svg" alt="" class="">
                    <span>CRM > Stage Management</span>
                  </a>
                </div>
              </mat-list-item>
              <mat-list-item>
                <!-- <mat-icon matListItemIcon>folder</mat-icon> -->
                <img src="./assets/images/icons/settings icon/white/templatesW.svg" alt="" class="">
                <span>Templates</span>
              </mat-list-item>
              <mat-list-item>
                <!-- <mat-icon matListItemIcon>folder</mat-icon> -->
                <img src="./assets/images/icons/settings icon/white/emailsW.svg" alt="" class="">
                <span>Emails</span>
              </mat-list-item>
              <mat-list-item>
                <!-- <mat-icon matListItemIcon>folder</mat-icon> -->
                <img src="./assets/images/icons/settings icon/white/smsW.svg" alt="" class="">
                <span>SMS Notifications</span>
              </mat-list-item>
              <mat-list-item>
                <!-- <mat-icon matListItemIcon>folder</mat-icon> -->
                <img src="./assets/images/icons/settings icon/white/reminderW.svg" alt="" class="">
                <span>Reminders</span>
              </mat-list-item>
              <!-- <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/informationsourcelistview">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/branchW.svg" alt="" class="">
                    <span>Information Source</span>
                  </a>
                </div>
              </mat-list-item> -->
              <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/salesEmployeelist">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/documentW.svg" alt="" class="">
                    <span>Sales Employee</span>
                  </a>
                </div>
              </mat-list-item>


              <!-- <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/bpmasterlist">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/reminderW.svg" alt="" class="">
                    <span>Customer Master</span>
                  </a>
                </div>
              </mat-list-item> -->
              <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/vendormasterlist">
                  <a>
                    <!-- <mat-icon matListItemIcon>folder</mat-icon> -->
                    <img src="./assets/images/icons/settings icon/white/reminderW.svg" alt="" class="">
                    <span>Vendor Master</span>
                  </a>
                </div>
              </mat-list-item>

              <!-- <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/competitorslistview">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/branchW.svg" alt="" class="">
                    <span>Competitors</span>
                  </a>
                </div>
              </mat-list-item> -->


              <!-- <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/itemmasterlistview">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/branchW.svg" alt="" class="">
                    <span>Item Master</span>
                  </a>
                </div>
              </mat-list-item> -->

              <!-- <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/leadmasterlist">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/reminderW.svg" alt="" class="">
                    <span>Lead Master</span>
                  </a>
                </div>
              </mat-list-item> -->

              <!-- <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/itemgrouplistview">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/branchW.svg" alt="" class="">
                    <span>Item Group</span>
                  </a>
                </div>
              </mat-list-item> -->

              <!-- <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/batchmasterlistview">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/branchW.svg" alt="" class="">
                    <span>Batch Master</span>
                  </a>
                </div>
              </mat-list-item> -->

              <!-- <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/crm/activitylistview">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/documentW.svg" alt="" class="">
                    <span>Activity</span>
                  </a>
                </div>
              </mat-list-item> -->


              <!-- <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/crm/inventorytransferlistview">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/documentW.svg" alt="" class="">
                    <span>Inventory Transfer</span>
                  </a>
                </div>

              </mat-list-item> -->
              <!-- <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/opportunitylistview">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/documentW.svg" alt="" class="">
                    Opportunity
                  </a>
                </div>

              </mat-list-item> -->
              <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/bpmasterlist">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/branchW.svg" alt="" class="">
                    <span>Business Partner Master</span>
                  </a>
                </div>
              </mat-list-item>

              <!-- <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/inventorycountinglistview">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/documentW.svg" alt="" class="">
                    <span>Inventory Counting</span>
                  </a>
                </div>

              </mat-list-item> -->

              <!-- <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/inventorypostinglistview">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/documentW.svg" alt="" class="">
                    <span>Inventory Posting</span>
                  </a>
                </div>
              </mat-list-item> -->
              <!-- <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/productionorderlistview">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/documentW.svg" alt="" class="">
                   Production Order
                  </a>
                </div>
              </mat-list-item> -->
              <!-- <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/serialnolistview">
                  <a>
                    <img src="./assets/images/icons/settings icon/white/documentW.svg" alt="" class="">
                    <span>Serial Number</span>
                  </a>
                </div>
              </mat-list-item> -->

              <!-- <mat-list-item>
                <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                  routerLink="/settings/issueForProductionOrderListView">
                  <a>
                    <img src="../../../assets/images/icons/settings icon/white/documentW.svg" alt="" class="">
                    Issue For Production
                  </a>
                </div>
              </mat-list-item> -->



            </mat-list>
          </perfect-scrollbar>
        </mat-menu>
      </li>
      <li class="top-menu-item">
        <!-- <button mat-button class="">
        
          <img src="./assets/images/icons/header/notification.svg" alt="" class="">
        </button> -->
      </li>
      <li class="top-menu-item">
        <span class="user-icon" [matMenuTriggerFor]="profile">
          <!-- <mat-icon>notifications_none</mat-icon> -->
          <span class="d-block"><mat-icon matTooltip="Profile {{curretUserInfo.UserName}} " class="material-icons color_green icon-button">person</mat-icon></span>
          <mat-menu #profile="matMenu" class="user-menu" yPosition="below">
            <!-- <div class="arrow-up"></div> -->
            <div class="d-flex pointer ps-2 mt-2">
              <div class="circle">
                {{ getFirstTwoChars(curretUserInfo.UserName) }}
              </div>&nbsp;
              <span class="mt-1">{{curretUserInfo.UserName}}</span>
            </div>
            <hr>
            <div class="d-flex pointer ps-2 mb-2" (click)="logout()">
              <!-- <mat-icon class=" .material-icons.color_white">person</mat-icon> -->
              <mat-icon>power_settings_new</mat-icon>&nbsp;
              <span>Log Out</span>
            </div>
          </mat-menu>
        </span>
      </li>
    </ul>
  </div>

</mat-toolbar>